import React from 'react';
import PropTypes from 'prop-types';
import { personalLabelProptypes } from 'sharedParts/config/personalLabelMap';
import RatingSegment from './RatingSegment';
import RatingIndex from './RatingIndex';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const RatingFormFooter = ({
  count,
  segmentLabelList,
  ratingItemClassName,
  selectedItemIndex,
  personalLabelType,
  isTouchedOrAnswered,
  shouldHideMobileSegment,
  indexClassName,
  startFromZero,
  segmentClassName,
  shouldHidePersonalIndex,
  styling,
  segmentType,
}) => (
  <div>
    {!shouldHidePersonalIndex && (
      <RatingIndex
        containerClassName={indexClassName}
        count={count}
        ratingItemClassName={ratingItemClassName}
        personalLabelType={personalLabelType}
        startFromZero={startFromZero}
      />
    )}
    <RatingSegment
      className={segmentClassName}
      shouldHideMobileSegment={shouldHideMobileSegment}
      isTouchedOrAnswered={isTouchedOrAnswered}
      labelList={segmentLabelList}
      ratingItemClassName={ratingItemClassName}
      count={count}
      selectedItemIndex={selectedItemIndex}
      styling={styling}
      segmentType={segmentType}
    />
  </div>
);

RatingFormFooter.propTypes = {
  count: PropTypes.number.isRequired,
  segmentType: PropTypes.string,
  indexClassName: PropTypes.string,
  segmentClassName: PropTypes.string,
  selectedItemIndex: PropTypes.number,
  personalLabelType: personalLabelProptypes,
  ratingItemClassName: PropTypes.string,
  shouldHidePersonalIndex: PropTypes.bool,
  isTouchedOrAnswered: PropTypes.bool,
  startFromZero: PropTypes.bool,
  shouldHideMobileSegment: PropTypes.bool,
  segmentLabelList: PropTypes.array,
  styling: propTypeBlockStyling,
};

export default RatingFormFooter;
